import { Link, useLocation } from 'react-router-dom';
import { cx } from '../../utils/helpers';
import { APP_NAME } from '../../config/app';

interface HeaderProps {
  isAdmin?: boolean;
}

export function Header({ isAdmin }: HeaderProps) {
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '';

  return (
    <header className="bg-masters-green text-white sticky top-0 z-40 shadow-lg">
      <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo / title */}
        <Link
          to="/"
          className={cx(
            'flex items-center gap-2 font-bold text-white',
            'focus:outline-none focus:ring-2 focus:ring-masters-gold rounded-lg px-1',
          )}
        >
          <span className="text-2xl" aria-hidden="true">⛳</span>
          <div className="leading-tight">
            <div className="text-sm font-black tracking-wide text-masters-gold">{APP_NAME}</div>
          </div>
        </Link>

        {/* Nav */}
        <nav className="flex items-center gap-1">
          {!isHome && (
            <Link
              to="/"
              className="p-2 rounded-lg hover:bg-masters-green-dark transition-colors text-sm font-medium"
              aria-label="Home"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l9-9 9 9M5 10v9a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-9" />
              </svg>
            </Link>
          )}

<Link
            to="/stats"
            className="p-2 rounded-lg hover:bg-masters-green-dark transition-colors text-sm font-medium"
            aria-label="Tournament stats"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
            </svg>
          </Link>
          <Link
            to="/leaderboard"
            className="p-2 rounded-lg hover:bg-masters-green-dark transition-colors text-sm font-medium"
            aria-label="Overall leaderboard"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </Link>
          <Link
            to="/admin"
            className={cx(
              'p-2 rounded-lg transition-colors text-sm font-semibold ml-1',
              isAdmin
                ? 'bg-masters-gold text-charcoal hover:bg-yellow-300'
                : 'hover:bg-masters-green-dark text-white',
            )}
            aria-label="Admin"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </Link>
        </nav>
      </div>
    </header>
  );
}
